/**
 * OpenCTI STIX Cyber Observable types (StixCyberObservableTypes).
 * Stored as ioc_type values so indicators align with OpenCTI naming.
 */
/** OpenCTI observable types — kept alphabetical by label for create/select UIs. */
export const OPENCTI_OBSERVABLE_TYPES = [
  { value: 'AI-Prompt', label: 'AI Prompt' },
  { value: 'Administrative-Area', label: 'Administrative Area (County)' },
  { value: 'Artifact', label: 'Artifact' },
  { value: 'Autonomous-System', label: 'Autonomous System' },
  { value: 'Bank-Account', label: 'Bank Account' },
  { value: 'City', label: 'City' },
  { value: 'Country', label: 'Country' },
  { value: 'Credential', label: 'Credential' },
  { value: 'Cryptocurrency-Wallet', label: 'Cryptocurrency Wallet' },
  { value: 'Cryptographic-Key', label: 'Cryptographic Key' },
  { value: 'Directory', label: 'Directory' },
  { value: 'Domain-Name', label: 'Domain Name' },
  { value: 'Email-Addr', label: 'Email Address' },
  { value: 'Email-Message', label: 'Email Message' },
  { value: 'Email-Mime-Part-Type', label: 'Email MIME Part' },
  { value: 'File', label: 'File' },
  { value: 'Hostname', label: 'Hostname' },
  { value: 'House-Number', label: 'House Number' },
  { value: 'ICCID', label: 'ICCID' },
  { value: 'IMEI', label: 'IMEI' },
  { value: 'IMSI', label: 'IMSI' },
  { value: 'IPv4-Addr', label: 'IPv4 Address' },
  { value: 'IPv6-Addr', label: 'IPv6 Address' },
  { value: 'Mac-Addr', label: 'MAC Address' },
  { value: 'Media-Content', label: 'Media Content' },
  { value: 'Mutex', label: 'Mutex' },
  { value: 'Network-Traffic', label: 'Network Traffic' },
  { value: 'Payment-Card', label: 'Payment Card' },
  { value: 'Persona', label: 'Persona' },
  { value: 'Phone-Number', label: 'Phone Number' },
  { value: 'Physical-Address', label: 'Physical Address' },
  { value: 'Postal-Code', label: 'Postal Code' },
  { value: 'Process', label: 'Process' },
  { value: 'SSH-Key', label: 'SSH Key' },
  { value: 'Simple-Observable', label: 'Simple Observable' },
  { value: 'Software', label: 'Software' },
  { value: 'State', label: 'State' },
  { value: 'Street-Address', label: 'Street Address' },
  { value: 'Text', label: 'Text' },
  { value: 'Tracking-Number', label: 'Tracking Number' },
  { value: 'Url', label: 'URL' },
  { value: 'User-Account', label: 'User Account' },
  { value: 'User-Agent', label: 'User Agent' },
  { value: 'Windows-Registry-Key', label: 'Windows Registry Key' },
  { value: 'Windows-Registry-Value-Type', label: 'Windows Registry Value' },
  { value: 'X509-Certificate', label: 'X.509 Certificate' },
];

/** Legacy Hivemind short names → OpenCTI type (for display / migration). */
export const LEGACY_IOC_TYPE_MAP = {
  domain: 'Domain-Name',
  ip: 'IPv4-Addr',
  ipv4: 'IPv4-Addr',
  ipv6: 'IPv6-Addr',
  email: 'Email-Addr',
  url: 'Url',
  phone: 'Phone-Number',
  address: 'Physical-Address',
  physical_address: 'Physical-Address',
  postal_address: 'Physical-Address',
  street_address: 'Physical-Address',
  wallet: 'Cryptocurrency-Wallet',
  hash: 'File',
  username: 'User-Account',
  other: 'Text',
  api_key: 'Credential',
  file_hash_sha256: 'File',
  file_hash_md5: 'File',
  file_hash_sha1: 'File',
};

export const DEFAULT_OBSERVABLE_TYPE = 'Domain-Name';

export function normalizeObservableType(raw) {
  if (!raw) return DEFAULT_OBSERVABLE_TYPE;
  if (OPENCTI_OBSERVABLE_TYPES.some((t) => t.value === raw)) return raw;
  const mapped = LEGACY_IOC_TYPE_MAP[String(raw).toLowerCase()];
  return mapped || raw;
}

export function observableTypeLabel(raw) {
  const normalized = normalizeObservableType(raw);
  const hit = OPENCTI_OBSERVABLE_TYPES.find((t) => t.value === normalized);
  return hit?.label || raw || 'Observable';
}

export const INDICATOR_CONFIDENCE_LEVELS = ['low', 'medium', 'high', 'confirmed'];
